(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "react-router"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("react-router"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactRouter);
    global.useRouteLocation = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _reactRouter) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.useRouteLocation = useRouteLocation;

  function useRouteLocation() {
    var location = (0, _reactRouter.useLocation)();
    var routeMatch = (0, _reactRouter.useRouteMatch)();
    var refLocation = (0, _react.useRef)(location);
    return (0, _react.useMemo)(function () {
      if (routeMatch.active) {
        refLocation.current = location;
      }

      return refLocation.current;
    }, [routeMatch, location]);
  }
});